/* Fotobaren — Tilbehør/tilvalg booking-gate.
   Accessories (tilbehør, rekvisitter, ballonger, bakgrunner, booking-tilvalg
   add-ons … i.e. every product that is not a fotobar rental or a gift card)
   can only be bought when
     (a) the cart already holds a fotobar rental (wizard flow), or
     (b) the customer verifies e-post + ordrenummer against an open fotobar
         booking (Make/Worker lookup → Shopify Admin), or
     (c) this browser session already identified an upcoming booking
         (this gate or Min booking).
   On (b)/(c) we stamp cart attributes so the Tilvalg→Podio Make scenario can
   attach the order to the right booking. Forms are classified server-side by
   snippets/fb-gate-kind.liquid (data-fb-gate="accessory|exempt"); unmarked
   product forms default to "accessory". (Johannes, Oct 2026: kunder skal ikke
   kunne kjøpe tilbehør uten fotobar i handlekurv eller en tidligere booking.) */
(function () {
  'use strict';

  var STORAGE_KEY = 'fb-tilvalg-booking';
  var RENTAL_TYPE_RE = /photobooth|fotobar|fotoboks/i;
  var ATTRS = {
    type: 'Booking: type',
    email: 'Booking: e-post',
    linked: 'Booking: linked-order',
    fra: 'Booking: fra',
    til: 'Booking: til',
    anledning: 'Booking: anledning',
  };

  function config() {
    var el = document.querySelector('[data-fb-booking-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* Variant ids of the fotobar rental product(s) the wizard sells. */
  function rentalVariantIds() {
    var c = config();
    if (!c || !c.product || !c.product.variants) return [];
    return c.product.variants.map(function (v) { return String(v.id); });
  }

  function lookupUrl() {
    var c = config();
    return (c && c.tilvalgLookupUrl) || '';
  }

  function minBookingUrl() {
    var c = config();
    return (c && c.minBookingUrl) || '/pages/min-booking';
  }

  var NO_LOOKUP_MSG = 'Tilbehør og tilvalg kan bare kjøpes sammen med en fotobar-booking. ' +
    'Reserver fotobar først, eller kontakt oss så hjelper vi deg.';

  function loadVerified() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { return null; }
  }

  function saveVerified(data) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function clearVerified() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function dayKey(iso) {
    return String(iso || '').slice(0, 10);
  }

  function diffDays(a, b) {
    var pa = String(a).slice(0, 10).split('-').map(Number);
    var pb = String(b).slice(0, 10).split('-').map(Number);
    return Math.round((new Date(pb[0], pb[1] - 1, pb[2]) - new Date(pa[0], pa[1] - 1, pa[2])) / 86400000);
  }

  /** Match wizard: Posten 4 / ekspress 2 / budbil·hent 1 (Johannes Oct 2026). */
  function deliveryLeadDays(levering, postnr) {
    var t = String(levering || '').toLowerCase();
    if (/ekspress/.test(t)) return 2;
    if (/budbil/.test(t)) return 1;
    if (/hent/.test(t)) return 1;
    return 4;
  }

  function osloParts() {
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Oslo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        hour12: false,
      }).formatToParts(new Date()).forEach(function (p) {
        if (p.type !== 'literal') parts[p.type] = p.value;
      });
    } catch (e) {
      var d = new Date();
      parts.year = String(d.getFullYear());
      parts.month = String(d.getMonth() + 1).padStart(2, '0');
      parts.day = String(d.getDate()).padStart(2, '0');
      parts.hour = String(d.getHours()).padStart(2, '0');
    }
    return parts;
  }

  function osloHour() {
    return parseInt(osloParts().hour, 10);
  }

  function beforeNoonOslo() {
    return osloHour() < 12;
  }

  function deadlineOpen(fra, leadDays, cutoffHour) {
    var event = dayKey(fra);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(event)) return false;
    var du = diffDays(todayKey(), event);
    if (du > leadDays) return true;
    if (du === leadDays) return osloHour() < cutoffHour;
    return false;
  }

  function isDesignProductTitle(title) {
    var t = String(title || '').toLowerCase();
    return /logo|ai[\s-]*filter|skreddersydd|green\s*screen|start[\s-]*skjerm|budskap|tilpass\s*start/.test(t);
  }

  function tilvalgLeadOk(booking, productTitle) {
    // Johannes Oct 2026:
    // Design (logo/AI/startskjerm): kl. 08 dagen før.
    // Fysisk tilbehør: frist for valgt leveringsmetode (kl. 12 på lead-dagen).
    var fra = dayKey(booking.fra);
    if (isDesignProductTitle(productTitle)) {
      if (deadlineOpen(fra, 1, 8)) return { ok: true };
      return {
        ok: false,
        need: 1,
        message: 'Design-tilvalg kan legges til frem til kl. 08 dagen før arrangementet (' +
          fmtDay(booking.fra) + '). Fristen er passert — kontakt oss om du trenger hjelp.',
      };
    }
    var lead = deliveryLeadDays(booking.levering, booking.postnr);
    if (deadlineOpen(fra, lead, 12)) return { ok: true };
    return {
      ok: false,
      need: lead,
      message: 'Dette tilbehøret følger fristen for ' +
        (booking.levering || 'valgt levering') + ' (kl. 12 ' + lead +
        ' dag' + (lead === 1 ? '' : 'er') + ' før ' + fmtDay(booking.fra) +
        '). Fristen er passert — kontakt oss om du trenger hjelp.',
    };
  }

  function fmtDay(iso) {
    var key = dayKey(iso);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(key)) return iso || '';
    var p = key.split('-');
    var months = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'];
    return parseInt(p[2], 10) + '. ' + months[parseInt(p[1], 10) - 1];
  }

  function todayKey() {
    var p = osloParts();
    return p.year + '-' + p.month + '-' + p.day;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* A fotobar rental line: wizard-stamped IzyRent line, the wizard's rental
     product, or anything typed Photobooth/Fotobar. */
  function isRentalItem(item) {
    if (!item) return false;
    if (item.properties && item.properties.__izyrentValidation) return true;
    if (rentalVariantIds().indexOf(String(item.variant_id)) !== -1) return true;
    return RENTAL_TYPE_RE.test(String(item.product_type || ''));
  }

  /* Cart already contains a rental being booked in this session — no gate. */
  function cartHasRental(cart) {
    return (cart.items || []).some(isRentalItem);
  }

  /* Everything that is neither a rental nor a gift card needs a booking. */
  function isGatedItem(item) {
    return !item.gift_card && !isRentalItem(item);
  }

  function cartHasAccessory(cart) {
    return (cart.items || []).some(isGatedItem);
  }

  /* 'accessory' | 'exempt'. Liquid marks forms via fb-gate-kind; forms without
     a marker (bundles, comparison tables, third-party snippets) default to
     accessory unless they sell the rental product itself. */
  function formGateKind(form) {
    var kind = form.getAttribute('data-fb-gate');
    if (kind === 'exempt' || kind === 'accessory') return kind;
    var input = form.querySelector('[name="id"]');
    var vid = input ? String(input.value) : '';
    if (vid && rentalVariantIds().indexOf(vid) !== -1) return 'exempt';
    return 'accessory';
  }

  /* Title for the lead-time rule: PDP h1, or the card the quick-add lives in. */
  function formProductTitle(form) {
    var card = form.closest('.product-card, .horizontal-product, [data-product-title]');
    var el = card && card.querySelector('.product-card__title, .horizontal-product__title, [data-product-title]');
    if (!el) el = document.querySelector('.product-title, h1');
    return (el && el.textContent.trim()) || document.title || '';
  }

  function stampCart(data) {
    var attributes = {};
    attributes[ATTRS.type] = 'tilvalg';
    attributes[ATTRS.email] = data.email;
    attributes[ATTRS.linked] = String(data.order).replace(/^#/, '');
    if (data.fra) attributes[ATTRS.fra] = data.fra;
    if (data.til) attributes[ATTRS.til] = data.til;
    if (data.anledning) attributes[ATTRS.anledning] = data.anledning;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    });
  }

  function lookup(email, order) {
    var url = lookupUrl();
    if (!url) return Promise.reject(new Error('missing-url'));
    var payload = { email: email };
    if (order) payload.order = String(order).replace(/^#/, '').trim();
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      if (!r.ok) throw new Error('lookup-http');
      return r.json();
    });
  }

  /* ---- modal ---- */
  var modal = null;
  var pending = null; // { resolve, reject }

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'fb-tilvalg-gate';
    modal.className = 'fb-tg';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="fb-tg__backdrop" data-fb-tg-close></div>' +
      '<div class="fb-tg__panel" role="dialog" aria-modal="true" aria-labelledby="fb-tg-title">' +
        '<button type="button" class="fb-tg__close" data-fb-tg-close aria-label="Lukk">×</button>' +
        '<h2 id="fb-tg-title">Kobling til booking</h2>' +
        '<p class="fb-tg__sub">Tilbehør og tilvalg kan bare kjøpes sammen med en fotobar-booking. Har du allerede booket? Skriv inn e-post og ordrenummer fra bekreftelsen, så kobler vi kjøpet til bookingen din.</p>' +
        '<label class="fb-tg__label" for="fb-tg-email">E-post</label>' +
        '<input id="fb-tg-email" class="fb-tg__input" type="email" autocomplete="email" placeholder="ola@epost.no">' +
        '<label class="fb-tg__label" for="fb-tg-order">Ordrenummer</label>' +
        '<input id="fb-tg-order" class="fb-tg__input" type="text" inputmode="numeric" autocomplete="off" placeholder="f.eks. 6057">' +
        '<div class="fb-tg__msg" data-fb-tg-msg hidden></div>' +
        '<button type="button" class="fb-tg__btn" data-fb-tg-submit>Finn booking</button>' +
        '<p class="fb-tg__hint">Ordrenummeret står i bekreftelses-e-posten og på <a href="' + esc(minBookingUrl()) + '">Min booking</a>.<br>' +
          'Ingen booking ennå? <a href="#fb-booking" data-fb-open-booking>Reserver fotobar først</a> — tilbehør legges til i samme bestilling.</p>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-fb-tg-close]')) {
        closeModal(new Error('cancelled'));
        return;
      }
      // Hand over to the booking wizard (fotobaren-booking.js listens on the
      // document for #fb-booking links) — close this gate first so the two
      // overlays don't stack.
      if (e.target.closest('a[href$="#fb-booking"]')) {
        closeModal(new Error('cancelled'));
      }
    });
    modal.querySelector('[data-fb-tg-submit]').addEventListener('click', onSubmit);
    function onEnter(e) {
      if (e.key === 'Enter') { e.preventDefault(); onSubmit(); }
    }
    modal.querySelector('#fb-tg-email').addEventListener('keydown', onEnter);
    modal.querySelector('#fb-tg-order').addEventListener('keydown', onEnter);
    return modal;
  }

  function setMsg(text, kind) {
    var el = modal.querySelector('[data-fb-tg-msg]');
    if (!text) { el.hidden = true; el.textContent = ''; return; }
    el.hidden = false;
    el.className = 'fb-tg__msg' + (kind ? ' fb-tg__msg--' + kind : '');
    el.textContent = text;
  }

  function openModal() {
    ensureModal();
    var v = loadVerified();
    modal.querySelector('#fb-tg-email').value = (v && v.email) || '';
    modal.querySelector('#fb-tg-order').value = (v && v.order) || '';
    setMsg('');
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function () { modal.querySelector('#fb-tg-email').focus(); }, 50);
    return new Promise(function (resolve, reject) {
      pending = { resolve: resolve, reject: reject };
    });
  }

  function closeModal(err) {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    if (pending) {
      var p = pending;
      pending = null;
      if (err) p.reject(err);
    }
  }

  function onSubmit() {
    var input = modal.querySelector('#fb-tg-email');
    var orderInput = modal.querySelector('#fb-tg-order');
    var email = (input.value || '').trim().toLowerCase();
    var order = ((orderInput && orderInput.value) || '').replace(/^#/, '').trim();
    if (!/.+@.+\..+/.test(email)) {
      setMsg('Skriv inn en gyldig e-postadresse.', 'err');
      return;
    }
    if (!/^\d+$/.test(order)) {
      setMsg('Skriv inn ordrenummeret (kun siffer, f.eks. 6057).', 'err');
      return;
    }
    var btn = modal.querySelector('[data-fb-tg-submit]');
    btn.disabled = true;
    btn.textContent = 'Søker…';
    setMsg('');
    lookup(email, order).then(function (data) {
      btn.disabled = false;
      btn.textContent = 'Finn booking';
      if (!data || !data.ok || !data.order || !data.fra) {
        setMsg('Fant ingen fotobar-booking med denne e-posten og ordrenummeret.', 'err');
        return;
      }
      if (String(data.order).replace(/^#/, '') !== order) {
        setMsg('Ordrenummeret matcher ikke bookingen vi fant. Sjekk bekreftelsen.', 'err');
        return;
      }
      // F9: past events can open Min booking for gallery info, but tilvalg PDP
      // purchases stay blocked after the event date.
      if (dayKey(data.fra) < todayKey()) {
        setMsg('Bookingen vi fant har allerede passert. Tilbehør og tilvalg kan bare legges til før arrangementet. Se galleriinfo på Min booking.', 'err');
        return;
      }
      var verified = {
        email: data.email || email,
        order: String(data.order).replace(/^#/, ''),
        fra: dayKey(data.fra),
        til: dayKey(data.til) || '',
        anledning: data.anledning || '',
        levering: data.levering || '',
        postnr: data.postnr || '',
      };
      saveVerified(verified);
      setMsg('Fant booking #' + verified.order + ' · ' + (verified.anledning ? verified.anledning + ' · ' : '') + fmtDay(verified.fra), 'ok');
      stampCart(verified).then(function () {
        var p = pending;
        pending = null;
        setTimeout(function () {
          modal.hidden = true;
          document.body.style.overflow = '';
          if (p) p.resolve(verified);
        }, 600);
      }).catch(function () {
        setMsg('Bookingen er funnet, men handlekurven kunne ikke oppdateres. Prøv igjen.', 'err');
      });
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Finn booking';
      setMsg('Klarte ikke å slå opp bookingen akkurat nå. Prøv igjen om litt.', 'err');
    });
  }

  /* Resolve to a booking the purchase can be linked to: (c) a booking already
     identified in this session, otherwise (b) the e-post + ordrenummer modal. */
  function ensureVerified() {
    var b = sessionBooking();
    if (b) {
      saveVerified(b);
      return stampCart(b).then(function () { return b; });
    }
    if (!lookupUrl()) {
      return Promise.reject(new Error('missing-url'));
    }
    return openModal();
  }

  /* ---- intercept add-to-cart on every accessory form (PDP, quick-add, …) ---- */
  function isProductForm(form) {
    return form && (form.getAttribute('is') === 'product-form' || form.dataset.type === 'add-to-cart-form');
  }

  function bindAtc() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!isProductForm(form)) return;
      if (form.dataset.fbTilvalgOk === '1') {
        delete form.dataset.fbTilvalgOk;
        return; // allow this submit through
      }
      if (formGateKind(form) !== 'accessory') return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var productTitle = formProductTitle(form);
      var submitter = e.submitter && e.submitter.form === form ? e.submitter : null;
      var proceed = function (booking) {
        if (booking) {
          var lead = tilvalgLeadOk(booking, productTitle);
          if (!lead.ok) {
            alert(lead.message);
            return;
          }
        }
        form.dataset.fbTilvalgOk = '1';
        if (typeof form.requestSubmit === 'function') {
          try { form.requestSubmit(submitter || undefined); } catch (err) { form.requestSubmit(); }
        } else {
          HTMLFormElement.prototype.submit.call(form);
        }
      };

      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        if (cartHasRental(cart)) {
          // (a) Rental in cart — wizard already enforced addon lead against its date/delivery.
          proceed(null);
          return;
        }
        ensureVerified().then(proceed).catch(function (err) {
          if (err && err.message === 'cancelled') return;
          if (err && err.message === 'missing-url') alert(NO_LOOKUP_MSG);
        });
      }).catch(function () {
        // Cart unreachable — fail closed, but let a session booking through.
        ensureVerified().then(proceed).catch(function (err) {
          if (err && err.message === 'missing-url') alert(NO_LOOKUP_MSG);
        });
      });
    }, true);
  }

  /* Booking the customer has already identified in this browser session —
     via this gate or via Min booking (fotobaren-min-booking.js stores its
     booking under `fb-min-booking`). Only upcoming, non-cancelled bookings. */
  function sessionBooking() {
    var candidates = [loadVerified()];
    try { candidates.push(JSON.parse(sessionStorage.getItem('fb-min-booking') || 'null')); } catch (e) {}
    for (var i = 0; i < candidates.length; i++) {
      var b = candidates[i];
      if (!b || !b.order || !b.email || b.cancelled || b.isDraft) continue;
      if (!/^\d+$/.test(String(b.order).replace(/^#/, ''))) continue; // D-numbers have no Podio external_id
      if (!b.fra || dayKey(b.fra) < todayKey()) continue;
      return {
        email: b.email,
        order: String(b.order).replace(/^#/, ''),
        fra: dayKey(b.fra),
        til: dayKey(b.til) || '',
        anledning: b.anledning || '',
        levering: b.levering || b.leveringsmetode || '',
        postnr: b.postnr || '',
      };
    }
    return null;
  }

  /* ---- cart page / drawer: link checkout to the booking, gate accessories ---- */
  function bindCheckoutGuard() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="/checkout"], button[name="checkout"], [href*="/checkout"]');
      if (!a) return;
      if (a.dataset.fbTgGo === '1') {
        delete a.dataset.fbTgGo;
        return; // re-dispatched by go() below — let the theme/Shopify handle it
      }

      e.preventDefault();
      e.stopPropagation();

      // Re-click the original control so the cart form (note, attributes) is
      // submitted exactly as it would have been without the guard.
      var go = function () {
        if (!document.body.contains(a)) { window.location.href = '/checkout'; return; }
        a.dataset.fbTgGo = '1';
        a.click();
      };
      var booking = sessionBooking();

      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        // A rental in the cart IS the booking — the wizard owns the attributes.
        if (cartHasRental(cart)) { go(); return; }
        // Nothing gated in the cart (gift cards only, or empty) — plain checkout.
        if (!cartHasAccessory(cart)) { go(); return; }
        var attrs = cart.attributes || {};
        if (attrs[ATTRS.type] === 'tilvalg' && attrs[ATTRS.linked]) { go(); return; }

        // Rental-less purchase (rekvisitter, tilbehør, tilvalg …) by a customer
        // who has an active booking in this session: stamp it as a tilvalg on
        // that booking so Make attaches it to the existing Podio event instead
        // of ignoring it — or, with stale wizard attrs, creating a new event
        // (#6154, Oct 2026).
        if (booking) {
          saveVerified(booking);
          stampCart(booking).then(go, go);
          return;
        }

        // Hard gate: accessory-only cart with no linked booking → verify first.
        ensureVerified().then(go).catch(function (err) {
          if (err && err.message === 'cancelled') return;
          if (err && err.message === 'missing-url') alert(NO_LOOKUP_MSG);
        });
      }).catch(function () {
        // Cart unreachable: a session booking still links; otherwise fail closed.
        if (booking) { go(); return; }
        ensureVerified().then(go).catch(function (err) {
          if (err && err.message === 'missing-url') alert(NO_LOOKUP_MSG);
        });
      });
    }, true);
  }

  function showVerifiedBadge() {
    var v = sessionBooking();
    if (!v) return;
    document.querySelectorAll('[data-fb-gated-product], [data-fb-tilvalg-product]').forEach(function (el) {
      if (el.querySelector('.fb-tg__badge')) return;
      var b = document.createElement('div');
      b.className = 'fb-tg__badge';
      b.innerHTML = 'Koblet til booking <strong>#' + esc(v.order) + '</strong> · ' + esc(fmtDay(v.fra)) +
        ' <button type="button" class="fb-tg__badge-clear">Bytt e-post</button>';
      b.querySelector('.fb-tg__badge-clear').addEventListener('click', function () {
        clearVerified();
        b.remove();
        openModal().catch(function () {});
      });
      el.insertBefore(b, el.firstChild);
    });
  }

  function init() {
    // The booking config (overlay-group → fb-booking-wizard) is rendered on
    // every storefront page. Without it we still gate — fail closed.
    bindCheckoutGuard();
    bindAtc();
    showVerifiedBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
